<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12">
      <div class="card tab2-card">
        <div class="card-header">
          <fieldset *ngIf="editable" visible style="border:none">
            <h5>Adauga contract retea</h5>
          </fieldset>
          <fieldset *ngIf="!editable" visible style="border:none">
            <h5>Detalii contract retea</h5>
          </fieldset>
        </div>
        <div class="card-body tab2-card">
          <fieldset *ngIf="editable" enabled style="border:none">
            <form [formGroup]="form" class="needs-validation" novalidate>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <h4> Date client</h4>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-1 col-md-1">
                  <label>Client<span>*</span></label>
                </div>
                <div class="col-xl-2 col-md-2">
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="client" (click)="setClient('CLIENT')"
                      [checked]="isClient()">
                    Client final
                  </label>
                </div>
                <div class="col-xl-2 col-md-2">
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="client" (click)="setClient('SUPPLIER')"
                      [checked]="isSupplier()">
                    Furnizor
                  </label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-auto col-md-auto">
                  <label>Tip client<span>*</span></label>
                </div>
                <div class="col-xl-2 col-md-2" *ngIf="!isSupplierSelected">
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="clientType" (click)="setClientType('INDIVIDUAL')"
                      [checked]="isIndividual()">
                    Persoana fizica
                  </label>
                </div>
                <div class="col-xl-2 col-md-2">
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="clientType" (click)="setClientType('LEGAL_PERSON')"
                      [checked]="isLegalPerson()">
                    Persoana juridica
                  </label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label>CUI/CNP<span>*</span></label>
                  <input class="form-control" type="text" formControlName="clientCode"
                    (change)="checkConsumptionPlaceVisibility()">
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Denumire<span>*</span></label>
                  <input class="form-control" type="text" formControlName="clientName">
                </div>
              </div>
              <br>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <h4> Date contract</h4>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label>Nr contract<span>*</span></label>
                  <input class="form-control" type="text" formControlName="contractNumber">
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Data contract<span>*</span></label>
                  <input class="form-control" type="date" formControlName="date" onkeydown="return false">
                </div>
              </div>
            </form>
            <br>
            <div *ngIf="consumptionPlacesListVisible">
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <h4> Lista loc de consum</h4>
                </div>
                <div class="col-xl-3 col-md-3">
                  <button type="button" class="btn btn-primary" (click)="searchPlaces()">
                    Cauta
                  </button>
                </div>
              </div>
              <div class="form-group row" *ngIf="places && places.length > 0">
                <div class="col-xl-2 col-md-2">
                  <label><b>POD</b></label>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label><b>Adresa</b></label>
                </div>
                <div class="col-xl-2 col-md-2">
                  <label><b>Status</b></label>
                </div>
                <!--<div class="col-xl-2 col-md-2" *ngIf="!isSupplierSelected">
                  <label><b>Nr. conventie</b></label>
                </div>-->
              </div>
              <div *ngIf="places">
                <div class="form-group row" *ngFor="let place of places">
                  <div class="col-xl-2 col-md-2">
                    <label>{{place.code}}</label>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>{{place.address}}</label>
                  </div>
                  <div class="col-xl-2 col-md-2">
                    <label>{{place.status}}</label>
                  </div>
                  <!--<div class="col-xl-2 col-md-2" *ngIf="!isSupplierSelected">
                    <input class="form-control" type="text" value="{{place.conventionNumber}}"
                           (dblclick)="openConvention(conventionModal, place)">
                  </div>-->
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset *ngIf="!editable" disabled style="border:none">
            <form [formGroup]="form" class="needs-validation" novalidate>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <h4> Date client</h4>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-1 col-md-1">
                  <label>Client<span>*</span></label>
                </div>
                <div class="col-xl-2 col-md-2">
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="client" (click)="setClient('CLIENT')"
                      [checked]="isClient()">
                    Client final
                  </label>
                </div>
                <div class="col-xl-2 col-md-2">
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="client" (click)="setClient('SUPPLIER')"
                      [checked]="isSupplier()">
                    Furnizor
                  </label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-auto col-md-auto">
                  <label>Tip client<span>*</span></label>
                </div>
                <div class="col-xl-2 col-md-2" *ngIf="!isSupplierSelected">
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="clientType" (click)="setClientType('INDIVIDUAL')"
                      [checked]="isIndividual()">
                    Persoana fizica
                  </label>
                </div>
                <div class="col-xl-2 col-md-2">
                  <label class="d-block">
                    <input class="radio_animated" type="radio" name="clientType" (click)="setClientType('LEGAL_PERSON')"
                      [checked]="isLegalPerson()">
                    Persoana juridica
                  </label>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label>CUI/CNP<span>*</span></label>
                  <input class="form-control" type="text" formControlName="clientCode"
                    (change)="checkConsumptionPlaceVisibility()">
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Denumire<span>*</span></label>
                  <input class="form-control" type="text" formControlName="clientName">
                </div>
              </div>
              <br>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <h4> Date contract</h4>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <label>Nr contract<span>*</span></label>
                  <input class="form-control" type="text" formControlName="contractNumber">
                </div>
                <div class="col-xl-3 col-md-3">
                  <label>Data contract<span>*</span></label>
                  <input class="form-control" type="date" formControlName="date" onkeydown="return false">
                </div>
              </div>
            </form>
            <br>
            <div *ngIf="consumptionPlacesListVisible">
              <div class="form-group row">
                <div class="col-xl-3 col-md-3">
                  <h4> Lista loc de consum</h4>
                </div>
                <div class="col-xl-3 col-md-3" *ngIf="editable">
                  <button type="button" class="btn btn-primary" (click)="searchPlaces()">
                    Cauta
                  </button>
                </div>
              </div>
              <div class="form-group row" *ngIf="places && places.length > 0">
                <div class="col-xl-1 col-md-1">
                  <label><b>POD</b></label>
                </div>
                <div class="col-xl-3 col-md-3">
                  <label><b>Adresa</b></label>
                </div>
                <div class="col-xl-2 col-md-2">
                  <label><b>Status</b></label>
                </div>
                <!--<div class="col-xl-2 col-md-2" *ngIf="isSupplierSelected">
                  <label><b>Nr. conventie</b></label>
                </div>-->
              </div>
              <div *ngIf="places">
                <div class="form-group row" *ngFor="let place of places">
                  <div class="col-xl-1 col-md-1">
                    <label>{{place.code}}</label>
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>{{place.address}}</label>
                  </div>
                  <div class="col-xl-2 col-md-2">
                    <label>{{place.status}}</label>
                  </div>
                  <!--<div class="col-xl-2 col-md-2" *ngIf="isSupplierSelected">
                    <label>{{place.conventionNumber}}</label>
                  </div>-->
                </div>
              </div>
            </div>
          </fieldset>
          <br>
          <div class="card-body tab2-card">
            <div class="tab-pane fade active show" id="place" role="tabpanel" aria-labelledby="account-tab">
              <form [formGroup]="placeForm" class="needs-validation" novalidate>
                <div class="form-group row">
                  <div class="col-xl-3 col-md-3">
                    <label>POD</label>
                    <input class="form-control" type="text" formControlName="code">
                  </div>
                  <div class="col-xl-3 col-md-3">
                    <label>Denumire client</label>
                    <input class="form-control" type="text" formControlName="client">
                  </div>
                  <div class="col-xl-1 col-md-1">
                    <button type="button" class="btn btn-primary" (click)="searchPlaces()">
                      Cauta
                    </button>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-xl-3 col-sm-3 mb-0">
                    <label>Judet</label>
                    <select class="form-control digits" formControlName="county" (change)="onChangeCounty()">
                      <option *ngFor="let county of counties" [value]="county.id">
                        {{ county.name }} </option>
                    </select>
                  </div>
                  <div class="col-xl-3 col-sm-3 mb-0">
                    <label>Localitate</label>
                    <select class="form-control digits" formControlName="city">
                      <option *ngFor="let city of cities" [value]="city.id">
                        {{ city.name }} </option>
                    </select>
                  </div>
                </div>
              </form>
              <br>
              <div class="category-table custom-datatable">
                <div class="table-responsive">
                  <ng2-smart-table [settings]="consumptionPlaceSettings"
                    [source]="electricityConsumptionPlaces?.content"
                    (custom)="onCustomActionConsumptionPlace($event)"></ng2-smart-table>
                </div>
              </div>
              <div *ngIf="electricityConsumptionPlaces?.totalElements > 0">
                <h4 class="pagination justify-content-center">
                  Total Locuri Consum {{electricityConsumptionPlaces.totalElements}}
                </h4>
                <ul class="pagination justify-content-center">
                  <li class="page-item" (click)="previousPage()">
                    <a class="page-link" aria-label="Previous">
                      <span aria-hidden="true">&laquo;</span>
                      <span class="sr-only">Previous</span>
                    </a>
                  </li>
                  <li *ngFor="let page of paginationElectricityConsumptionPlaces" [ngClass]="page.className"
                    (click)="changePage(page)">
                    <a class="page-link">{{page.pageNumber + 1}}</a>
                  </li>
                  <li class="page-item" (click)="nextPage()">
                    <a class="page-link" aria-label="Next">
                      <span aria-hidden="true">&raquo;</span>
                      <span class="sr-only">Next</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="form-group row mb-0 pull-right">
            <div class="col-xl-auto col-md-auto">
              <button [routerLink]="'..'" type="button" class="btn btn-light button-margin">Renunta</button>
              <button type="button" *ngIf="editable" class="btn btn-primary mr-1 button-margin" (click)="onSubmit()">
                Salveaza
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--<ng-template #conventionModal let-modal>
    <form [formGroup]="conventionForm" class="needs-validation" novalidate>
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Modifica conventie</h4>
      </div>
      <div class="modal-body">
        <div class="form-group row">
          <div class="col-xl-6 col-md-6">
            <label>Nr conventie<span>*</span></label>
            <input class="form-control" type="text" formControlName="conventionNumber">
          </div>
          <div class="col-xl-6 col-md-6">
            <label>Data conventie<span>*</span></label>
            <input class="form-control" type="date" formControlName="conventionDate" onkeydown="return false">
          </div>
        </div>
        <div class="form-group row">
          <div class="col-xl-2 col-md-2">
            <label>Parti conventie</label>
          </div>
          <div class="col-xl-6 col-md-6 overflow-auto border">
            <div *ngFor="let part of conventionParts" class="row">
              <span class="list-item">{{part}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="form-group row">
          <button (click)="modal.dismiss('Cross click')" type="button" class="btn btn-light button-margin">Renunta
          </button>
          <button type="button" class="btn btn-primary mr-1 button-margin"
                  (click)="createConvention()">
            Salveaza
          </button>
        </div>
      </div>
    </form>
  </ng-template>-->
</div>